/* Noire Atelier — facets.js */
(function () {
  'use strict';

  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[data-facet-form]');
      this.sectionId = this.dataset.sectionId;
      if (!this.form || !this.sectionId) return;
      this.basePath = this.dataset.baseUrl || window.location.pathname;
      this.debouncedSubmit = window.NoireUtils.debounce(() => this.applyFilters(), 500);
      this.form.addEventListener('input', (e) => {
        if (e.target.matches('input[type="number"]')) this.debouncedSubmit();
      });
      this.form.addEventListener('change', (e) => {
        if (!e.target.matches('input[type="number"]')) this.applyFilters();
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.applyFilters();
      });
      document.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-facet-remove]');
        if (chip) {
          e.preventDefault();
          this.fetchAndRender(chip.getAttribute('href'), true);
          return;
        }
        const loadMore = e.target.closest('[data-load-more]');
        if (loadMore) {
          e.preventDefault();
          this.loadMore(loadMore);
        }
      });
      document.addEventListener('change', (e) => {
        const sort = e.target.closest('select[data-facet-sort]');
        if (sort && this.form && sort.getAttribute('form') === this.form.id) this.applyFilters();
      });
      window.addEventListener('popstate', () => this.fetchAndRender(window.location.href, false));
      const mq = window.matchMedia('(max-width: 989px)');
      const details = this.querySelector('.facets-disclosure');
      if (details && mq.matches && !this.classList.contains('facets-drawer-only')) details.removeAttribute('open');
    }
    serialize() {
      const params = new URLSearchParams(new FormData(this.form));
      Array.from(params.keys()).forEach((k) => {
        if (params.getAll(k).every((v) => v === '')) params.delete(k);
      });
      return params.toString();
    }
    applyFilters() {
      const query = this.serialize();
      const url = this.basePath + (query ? '?' + query : '');
      this.fetchAndRender(url, true);
    }
    fetchAndRender(url, push) {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.sectionId);
      const results = document.querySelector('[data-facets-results]');
      if (results) results.setAttribute('aria-busy', 'true');
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      fetch(target.toString(), { signal: this.controller.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          this.swap(doc, '[data-facets-results]');
          this.swapForm(doc);
          if (results) results.removeAttribute('aria-busy');
          const cleanUrl = new URL(target.toString());
          cleanUrl.searchParams.delete('section_id');
          if (push) window.history.pushState({}, '', cleanUrl.toString());
          const count = document.querySelector('[data-results-count]');
          if (count) window.NoireUtils.announce(count.textContent.trim());
        })
        .catch(() => { if (results) results.removeAttribute('aria-busy'); });
    }
    swap(doc, selector) {
      const fresh = doc.querySelector(selector);
      const current = document.querySelector(selector);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
    swapForm(doc) {
      const wrap = this.querySelector('[data-facets-form-wrap]');
      const fresh = doc.querySelector('[data-facets-form-wrap]');
      if (!wrap || !fresh) return;
      const openGroups = Array.from(wrap.querySelectorAll('.facet-group')).map((d) => d.hasAttribute('open'));
      const activeId = document.activeElement && document.activeElement.id;
      wrap.innerHTML = fresh.innerHTML;
      Array.from(wrap.querySelectorAll('.facet-group')).forEach((d, i) => {
        if (openGroups[i]) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
      this.form = this.querySelector('form[data-facet-form]');
      if (activeId) {
        const el = document.getElementById(activeId);
        if (el) el.focus({ preventScroll: true });
      }
    }
    loadMore(button) {
      const href = button.getAttribute('href');
      if (!href) return;
      button.classList.add('is-loading');
      const target = new URL(href, window.location.origin);
      target.searchParams.set('section_id', this.sectionId);
      fetch(target.toString())
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const freshGrid = doc.querySelector('[data-grid]');
          const grid = document.querySelector('[data-grid]');
          const wrap = document.querySelector('[data-load-more-wrap]');
          const freshWrap = doc.querySelector('[data-load-more-wrap]');
          if (freshGrid && grid) {
            Array.from(freshGrid.children).forEach((child) => grid.appendChild(child));
          }
          if (wrap) {
            if (freshWrap) wrap.innerHTML = freshWrap.innerHTML;
            else wrap.innerHTML = '';
          }
          window.NoireUtils.announce(window.a11yStrings.loading);
        })
        .catch(() => button.classList.remove('is-loading'));
    }
  }
  if (!customElements.get('facet-filters-form')) customElements.define('facet-filters-form', FacetFiltersForm);
})();
